import React from 'react';
import Button from '../ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => (
    <div className="flex flex-col items-center justify-center text-center px-4" style={{ minHeight: '70vh' }}>
        <p className="font-serif text-7xl sm:text-8xl font-medium text-brand-500">404</p>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-4">Page not found</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-2 mb-6">
            The page you're looking for doesn't exist or has moved.
        </p>
        <Button to="/" size="lg">
            <FontAwesomeIcon icon={faArrowLeft} /> Back home
        </Button>
    </div>
);

export default NotFound;
